import React from 'react';
import { Element } from 'react-scroll';
import data from './data.json';
import './styles/index.css';
import { SyllabusTitle } from '../../Packages/Sections/LandingSyllabus/styles';
import VideoTestimonialSection from './VideoTestimonialSection';
import TestimonialsGridItem from './TestimonialsGridItem';

export default function Testimonials({ variant }) {
  const slice = data.slice(0, 12);
  return (
    <Element name="reviews" id="reviews">
      <section className="outer-section" id="testimonialsContainer">
        <div className="inner-section">
          <div className="text-center">
            <SyllabusTitle>Stories from real people</SyllabusTitle>
          </div>

          {variant === 'code-juniors' ? <VideoTestimonialSection variant={variant} /> : null}

          <div className="testimonial-grid-row">
            {slice.map((data) => {
              return <TestimonialsGridItem key={data.id} data={data} variant={variant} />;
            })}
          </div>
        </div>
      </section>
    </Element>
  );
}
